export const checkBoxLabel =
  "This action is permanent and cannot be undone. All your profile details, messages, and matches will be permanently removed. If you just need a break, consider deactivating your account instead.";

export const RadioData = [
  { label: "I found a match", value: 1 },
  { label: "Inactive or not interested", value: 2 },
  { label: "Privacy concerns", value: 3 },
  { label: "Unsatisfactory experience", value: 4 },
  { label: "Multiple accounts", value: 5 },
  { label: "Subscription or payment issues", value: 6 },
  { label: "Personal reasons", value: 7 },
];
